export const getGroupsByStore = groups => {
  const storesById = new Map()

  groups.forEach(group => {
    const { store } = group

    if (!storesById.has(store.id)) storesById.set(store.id, { id: store.id, name: store.name, groups: [] })

    storesById.get(store.id).groups.push(group)
  })

  return [...storesById.values()]
}
